class SvgGenerator {
	constructor(elements) {
		this.images = document.querySelectorAll(elements);
	}

	loadContent(url, parent, el, from, $class) {
		let http = new XMLHttpRequest();

		http.open('GET', url);

		http.onreadystatechange = function () {
			if (this.readyState === 4 && this.status === 200) {
				const doc = new DOMParser().parseFromString(this.responseText, "text/html");
				let svg = doc.getElementsByTagName(from)[0];
				parent.insertBefore(svg, el.nextSibling);
				if($class) svg.classList.add($class);
			}
		};

		http.send(null);
	}

	init() {
		if(!this.images) return;
		[...this.images]
			.filter(el => {
				let attr = el.getAttribute('data-svg');

				if(!attr) {
					attr = el.src
				}

				return  attr.slice(-4) === '.svg'
			})
			.forEach((el) => {
				let parent = el.parentElement;
				let $class = el.getAttribute('class');
				let path = el.getAttribute('data-svg');

				if(!path) {
					path = el.src
				}

				if(!parent) return;

				this.loadContent(path, parent, el, 'svg', $class);
				el.remove();
			})
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new SvgGenerator('[data-svg]').init();
});